import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import NavButtons from 'components/Advanced_User/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Using your XiaoMi Home Hardware without the Cloud",
  "path": "/Advanced_User/XiaoMi_Home_Zigbee2MQTT/",
  "dateChanged": "2018-09-20",
  "author": "Mike Polinowski",
  "excerpt": "Zigbee to MQTT bridge, get rid of your proprietary Zigbee bridges. zigbee2mqtt bridges events and allows you to control your Zigbee devices via MQTT. In this way you can integrate your Zigbee devices with whatever smart home infrastructure you are using. Compatible with the camera models IN-6001 HD, IN-6012 HD, IN-6014 HD, IN-5905 HD, IN-5907 HD, IN-7011 HD, IN-8003 Full HD, IN-8015 Full HD, IN-9008 Full HD, IN-9020 Full HD",
  "image": "./AU_SearchThumb_Zigbee.png",
  "social": "/images/Search/AU_SearchThumb_Zigbee.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_Advanced_ZigBee_white.webp",
  "chapter": "Advanced User",
  "category": "smarthome",
  "type": "Node-RED"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <SEOHelmet title='Using your XiaoMi Home Hardware without the Cloud' dateChanged='2018-09-20' author='Mike Polinowski' tag='INSTAR IP Camera' description='Zigbee to MQTT bridge, get rid of your proprietary Zigbee bridges. zigbee2mqtt bridges events and allows you to control your Zigbee devices via MQTT. In this way you can integrate your Zigbee devices with whatever smart home infrastructure you are using. Compatible with the camera models IN-6001 HD, IN-6012 HD, IN-6014 HD, IN-5905 HD, IN-5907 HD, IN-7011 HD, IN-8003 Full HD, IN-8015 Full HD, IN-9008 Full HD, IN-9020 Full HD' image='/images/Search/TOC_Icons/Wiki_Tiles_Advanced_ZigBee_white.png' twitter='/images/Search/TOC_Icons/Wiki_Tiles_Advanced_ZigBee_white.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationEN={props.location.pathname} locationDE='/de/Erweitert/XiaoMi_Home_Zigbee2MQTT/' locationFR='/fr/Advanced_User/XiaoMi_Home_Zigbee2MQTT/' crumbLabel="Zigbee" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h1 {...{
      "id": "using-your-xiaomi-home-hardware-without-the-cloud",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#using-your-xiaomi-home-hardware-without-the-cloud",
        "aria-label": "using your xiaomi home hardware without the cloud permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Using your XiaoMi Home Hardware without the Cloud`}</h1>
    {/* TOC */}
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#zigbee-communication-without-a-proprietary-hub"
        }}>{`ZigBee Communication without a proprietary Hub`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#setting-up-the-bridge"
            }}>{`Setting up the bridge`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#running-the-bridge"
            }}>{`Running the bridge`}</a>
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#determine-location-of-cc2531-usb-sniffer-and-checking-user-permissions"
                }}>{`Determine location of CC2531 USB sniffer and checking user permissions`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#installation"
                }}>{`Installation`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#configuration"
                }}>{`Configuration`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#running-zigbee2mqtt"
                }}>{`Running ZigBee2MQTT`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#running-zigbee2mqtt-as-a-daemon"
                }}>{`Running ZigBee2MQTT as a Daemon`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#update-zigbee2mqtt-to-the-latest-version"
                }}>{`Update zigbee2mqtt to the latest version`}</a></li>
            </ul>
          </li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#pairing-devices"
            }}>{`Pairing Devices`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#using-zigbee-devices-to-control-instar-ip-cameras-in-node-red"
        }}>{`Using Zigbee Devices to control INSTAR IP Cameras in Node-RED`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#add-the-mqtt-input-to-an-existing-flow"
            }}>{`Add the MQTT input to an existing Flow`}</a></li>
        </ul>
      </li>
    </ul>
    {/* /TOC */}
    <h2 {...{
      "id": "zigbee-communication-without-a-proprietary-hub",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#zigbee-communication-without-a-proprietary-hub",
        "aria-label": "zigbee communication without a proprietary hub permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`ZigBee Communication without a proprietary Hub`}</h2>
    <p>{`Zigbee is a specification for a suite of high-level communication protocols used to create personal area networks with small, low-power digital radios, such as for home automation, medical device data collection, and other low-power low-bandwidth needs, designed for small scale projects which need wireless connection. Hence, Zigbee is a low-power, low data rate, and close proximity wireless ad hoc network.`}</p>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://github.com/Koenkk/zigbee2mqtt"
      }}>{`Zigbee2MQTT`}</a>{` bridge enables you to use selected `}<a parentName="p" {...{
        "href": "https://github.com/Koenkk/zigbee2mqtt/wiki/Supported-devices"
      }}>{`supported ZigBee devices`}</a>{` `}<strong parentName="p">{`without the otherwise mandatory Hub and Vendor Cloud`}</strong>{` connection. Among the devices that you can control are smart (ZigBee) light bulbs from Belkin, IKEA, OSRAM and Philips as well as smart sensors from SmartThings and Xiaomi.`}</p>
    <p>{`In this tutorial we are going to install the ZigBee2MQTT bridge together with Xiaomi smart sensors / buttons, on the hardware side, and `}<a parentName="p" {...{
        "href": "/en/Software/Linux/Node-RED/"
      }}>{`Node-RED`}</a>{` and `}<a parentName="p" {...{
        "href": "/en/Software/Linux/Home_Assistant/"
      }}>{`Home Assistant`}</a>{`, on the software side, to control our INSTAR IP Camera.`}</p>
    <p>{`The ZigBee bridge consists of a `}<strong parentName="p">{`ZigBee Sniffer Module`}</strong>{` and a controlling software written in `}<strong parentName="p">{`Node.js`}</strong>{`. It bridges events and allows you to control your Zigbee devices via `}<strong parentName="p">{`MQTT`}</strong>{`. In this way you can integrate your Zigbee devices with whatever smart home infrastructure you are using.`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/Koenkk/zigbee2mqtt/wiki/Getting-started#1-hardware-requirements"
      }}>{`Needed Hardware`}</a>{`:`}</p>
    <ul>
      <li parentName="ul">{`CC debugger`}</li>
      <li parentName="ul">{`CC2531 USB sniffer`}</li>
      <li parentName="ul">{`Downloader cable CC2531`}</li>
      <li parentName="ul">{`PC or Raspberry Pi to run bridge	`}</li>
    </ul>
    <p>{`The Debugger, Sniffer and connecting cable can be ordered directly through `}<a parentName="p" {...{
        "href": "https://community.home-assistant.io/t/zigbee2mqtt-getting-rid-of-your-proprietary-zigbee-bridges-xiaomi-hue-tradfri/52108/193"
      }}>{`online shops like AliExpress`}</a>{`.`}</p>
    <p>{`The debugger and cable are only used once to flash the firmware onto the stick. There is alternative way to do that `}<a parentName="p" {...{
        "href": "https://github.com/Koenkk/zigbee2mqtt/wiki/Alternative-firmware-flashing-methods"
      }}>{`using an Arduino board instead`}</a>{`.`}</p>
    <h3 {...{
      "id": "setting-up-the-bridge",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#setting-up-the-bridge",
        "aria-label": "setting up the bridge permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Setting up the bridge`}</h3>
    <p>{`The following description shows you how to flash the hardware onto your CC2531 stick under Windows 10 - `}<a parentName="p" {...{
        "href": "https://github.com/Koenkk/zigbee2mqtt/wiki/Getting-started#for-linuxmacos"
      }}>{`for Linux or macOS please follow this link`}</a>{`.`}</p>
    <ol>
      <li parentName="ol">{`Install `}<a parentName="li" {...{
          "href": "http://www.ti.com/tool/FLASH-PROGRAMMER"
        }}>{`SmartRF Flash programmer`}</a>{` (`}<strong parentName="li">{`NOT V2`}</strong>{`). This software is free but requires a Texas Instruments account in order to download.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/983bf5269150f333772ce890283f6c21/e9beb/flash_00.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "77.39130434782608%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAA7CAAAOwgEVKEqAAAACuUlEQVQ4y62SzW8bVRTF5+9ikzqbUqVdkCAF1AICxI4FO7pCrFggFoh2A2xg3zVCAiG6aJvEsaM0cm3HdlCT2p4Pz8yb9954ZjwfP/RebKnsQOJKR/fe93Hm3PPGuffBR7z7/ofc/+JLjronHHa6HHZPeHLU5mm7w0Gny7PjLk/bxzw5Orb1s+OOPXPSe0Hn+RlngyE//vQz7338Cc7y4IDpcMCr0YiLXo/x2RnRdEqTplRKUWtNbfK6rqSkShLqVUH2y6/ITz9D/fUSEQuKROKMd3fpb7d4sbVFf2vL5kGrxXB7+xqtFqM3bzF5Z5/Rzg4Xd+8x3ttjsr/P6OZNJrdvM357j9HuLud37uBkwyHZYEDW71/n19Hvo3s9i3SzvzlvcH5ONpn8Y80JlcKNY+ZhxEIpPCFwowhPxLYvgXqNfxOO586ZTad4foDrusymM8LFgny5JNWK/xpOkiQIKYmGQ+YXF1xNpwS+j+/7SJ2ifJ/FYMDc8/BcF3c+J0oS5GyG//tvVoTn+XZdCIGTLZdkRUF6dUlwdYkXBJZsbg5IiVosiMZjvPVHDEEkBCoICE9PbR8EAZ7nXhOmaUoiBDJN+T/CUVIShqElbZqGuq4pi4JVnlOuVtd1llHkBWVZslqtqKrKwuxverNn4BRFgTQ/a1XZL5gcLzNUVSHznKSu0IDIMmSSoJRCa0UsYoRBItBaszDWRBGOVsp6YwwPw8gqCttt9OEh5ctLlt98S/rV11SjCc16LKPECDF5IyLPc9LlEmcjtyorSlNnGeGjR3g/fE/6+DFi5y2iN25Q/PGnJayLwtpSN421aGOTCUNqXzmOYwszuvHEjLVR06xVmNCnp7z6/D5qPCarKlZFYdc3d8zojmE1jXkcpTWF1ngPH+I9+I5mfaExCowS8wBS0qz9Nupez8aGvwFH4kxUXmZsGAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/983bf5269150f333772ce890283f6c21/e4706/flash_00.avif 230w", "/en/static/983bf5269150f333772ce890283f6c21/d1af7/flash_00.avif 460w", "/en/static/983bf5269150f333772ce890283f6c21/b6582/flash_00.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/983bf5269150f333772ce890283f6c21/a0b58/flash_00.webp 230w", "/en/static/983bf5269150f333772ce890283f6c21/bc10c/flash_00.webp 460w", "/en/static/983bf5269150f333772ce890283f6c21/87ca7/flash_00.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/983bf5269150f333772ce890283f6c21/81c8e/flash_00.png 230w", "/en/static/983bf5269150f333772ce890283f6c21/08a84/flash_00.png 460w", "/en/static/983bf5269150f333772ce890283f6c21/e9beb/flash_00.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/983bf5269150f333772ce890283f6c21/e9beb/flash_00.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Install the `}<a parentName="li" {...{
          "href": "http://www.ti.com/general/docs/lit/getliterature.tsp?baseLiteratureNumber=swrc212&fileType=zip"
        }}>{`CC debugger driver`}</a>{` on your PC (Windows only). Before continuing, verify that the CC Debugger driver has been installed correctly. In case the CC Debugger is not recognized correctly `}<a parentName="li" {...{
          "href": "https://www.youtube.com/watch?v=jyKrxxXOvQY"
        }}>{`install the driver manually`}</a>{`.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/b39cf2db7e61283fa70e61d86bda766f/e9beb/driver_00.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.60869565217391%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACCElEQVQoz1WQ2W7bMBBF/f+fU6DPXQIEzUsCO04tS6JIrdzJsSSS1urCTt0mB/MyAxzci9k457xzwzAsyzLPo5KsrhpOqeTC99f7NI7XmaZ5nkPwAPpyY13XTVlWXPAko1nRVNI0TcmFlFpXlDIhoOv8MLg7fd8LQUMI5xsbhDEiJIqzRkgmuLXKKh0o66r60raXtrvA6TLP97RFSnote2Mjooh8+5F9/4kfHlldn6fzVJTsZatT5PKi3u3F22HE5F1elgVAr+v7dtmUBxR9+Vo9PE7HZAz+PA1jioqXrSpKxwXP8KTMnKB/srXqv3womuMhKvOiuz6uOw9+6fvm+dnGiYli9OtJH466rCyAENJ7d0v+a2+yPEvjJCd5XdWc0UbbLaJPUVEY3/ZdSRl0vQXQSp1O7T35LiNSpCky2rjeScGVVjHKX38fpba+78Harm1PACGEW+35U+1todIU06YBAOd6rQTOsjSJjdaUMoIxJiSJU4QyY0wIAeBDcoxxmqQE47btpmm0RmGcpykCAGuBc2as9d4755ZlXdfPD4tRfDxEjLJ5XkJw1iqCSRwn1yK9sxa89/M8T9M0Xhk+yUVdJXFCsqwqq/Z0AjCM8aqsTm3bX2ULAEppIaW6YYz8kEyK3e71bb8vi6quy5wgraVSQkomBJWScd4kyZGQDKH4bb/jvL7c+QN1rNMibid1dQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/b39cf2db7e61283fa70e61d86bda766f/e4706/driver_00.avif 230w", "/en/static/b39cf2db7e61283fa70e61d86bda766f/d1af7/driver_00.avif 460w", "/en/static/b39cf2db7e61283fa70e61d86bda766f/b6582/driver_00.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/b39cf2db7e61283fa70e61d86bda766f/a0b58/driver_00.webp 230w", "/en/static/b39cf2db7e61283fa70e61d86bda766f/bc10c/driver_00.webp 460w", "/en/static/b39cf2db7e61283fa70e61d86bda766f/87ca7/driver_00.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/b39cf2db7e61283fa70e61d86bda766f/81c8e/driver_00.png 230w", "/en/static/b39cf2db7e61283fa70e61d86bda766f/08a84/driver_00.png 460w", "/en/static/b39cf2db7e61283fa70e61d86bda766f/e9beb/driver_00.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/b39cf2db7e61283fa70e61d86bda766f/e9beb/driver_00.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Connect `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`CC debugger`}</code>{` --> `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Downloader cable CC2531`}</code>{` --> `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`CC2531 USB sniffer`}</code>{`.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/b7639d155aa03a2ddf678e20119f7a5d/e9beb/ccdebugger_00.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "55.65217391304348%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABtElEQVQoz2NgwAYYGRkZGBg4ONizMyOVFeXgIkQBJiaQUlMzvdnTGyUkxBgYGJiZmbHrZwQDNGvZWFmrCgvmzZxaVVJsZGSIbDmaejRrmRgYGESFhYPjgg1dTVXlFTNSkz3cXQUFBSBSKICbi5ufj5+NjQ3ZZk0rnbDSWEEZEZCbmZiszMzjo6NTExNcnRz5+HnZuThASllZWVWVlfR1dfR0dEwMDY0NDM1MTJQUFQXUxMQclVg42ZiZmFlYWOA2cbFzyMhLGXmZyyjJMAgK8OnoaMjKSomJCUtJiisrKZqZGEvLSrMyMbMzMLMwIPzJzMwMcbaYqLClt6WMuhwDLx+3hrqyjLSksLCAkBC/qZGhtaW5haFhSUH+hjUrOhqqs+OjXCzMBbi44T7i5eGRU5YXlRZj4OLmMNTXlZaSEBEW0FBX0dJQU1SQ8/F2T0pOqG+siYoJCwrxyc6Iq8hLi/LzVpKRsTU1D/XyE5MQ4+LlYmBjYxUU4BMU5BMSEtDSVJeTkRIXE+Xh5UULVCERQUsrEwtTI1V5RWlRMeRQAHuJiYmFhZmLi4ODgx3uSbA3mXDFKgDsBzvvAN/pjwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/b7639d155aa03a2ddf678e20119f7a5d/e4706/ccdebugger_00.avif 230w", "/en/static/b7639d155aa03a2ddf678e20119f7a5d/d1af7/ccdebugger_00.avif 460w", "/en/static/b7639d155aa03a2ddf678e20119f7a5d/b6582/ccdebugger_00.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/b7639d155aa03a2ddf678e20119f7a5d/a0b58/ccdebugger_00.webp 230w", "/en/static/b7639d155aa03a2ddf678e20119f7a5d/bc10c/ccdebugger_00.webp 460w", "/en/static/b7639d155aa03a2ddf678e20119f7a5d/87ca7/ccdebugger_00.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/b7639d155aa03a2ddf678e20119f7a5d/81c8e/ccdebugger_00.png 230w", "/en/static/b7639d155aa03a2ddf678e20119f7a5d/08a84/ccdebugger_00.png 460w", "/en/static/b7639d155aa03a2ddf678e20119f7a5d/e9beb/ccdebugger_00.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/b7639d155aa03a2ddf678e20119f7a5d/e9beb/ccdebugger_00.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Connect `}<strong parentName="li">{`BOTH`}</strong>{` the `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`CC2531 USB sniffer`}</code>{` and the `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`CC debugger`}</code>{` to your PC using USB.`}</li>
      <li parentName="ol">{`If the light on the CC debugger is RED press set reset button on the CC debugger. The light on the CC debugger should now turn GREEN. If not use `}<a parentName="li" {...{
          "href": "http://www.ti.com/lit/ug/swru197h/swru197h.pdf"
        }}>{`CC debugger user guide`}</a>{` to troubleshoot your problem. `}</li>
      <li parentName="ol">{`Download the firmware `}<a parentName="li" {...{
          "href": "https://raw.githubusercontent.com/Koenkk/Z-Stack-firmware/master/coordinator/CC2531/bin/CC2531ZNP-Prod.hex"
        }}>{`CC2531ZNP-Prod.hex`}</a></li>
      <li parentName="ol">{`Start SmartRF Flash Programmer, setup as shown below and press `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Perform actions`}</code>{`. `}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "702px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/1c6c877c2d14178a31f0c35525c8612a/d6331/flash_01.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "86.95652173913044%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAAA7CAAAOwgEVKEqAAAAD6klEQVQ4y1WUW2wUVRiABxEwmoYiBXolGkNrWom88EZqqkGr0ICGAFVUJAheYooxqFFiTQxgeIHoA/FBDIYoJEUTMaBImrb0AgVtbTvd3dmdnd2d2Zmdy95LW3rhMzNLsTx8Ocm5fOf8//nPEfZ/cpyDX5+l5chZPjj8M1+cOI8SUdFUlXhcJ5lMkk6nsW2bfD7P5MQEE/MYHx+/x9jYGMLjDS08u/8kjzUdZWnDlxQ3tDIw5Mc3KiKKBQYGB73WlVqWRSKR8DZJplKk5uH2CSXr91G75Qjr3j3Fk++cZs32bxgaDRKNKERjMeKaStKxmZ6a5PbkBPlcllwmzfitsfu4dStPJptBWLR2D0LTMRZ91IbwYRul7/9IKKKRy2WJij5utncz1HuDwe7r+PoHCA/5CA6OMtTj9vUz3Pc3A939+K4PoIfCCEs3fUbJV+2UHL3CI60XqWq9QDBmkM9n8P0r0fbnCL9eGeXcH8Nc6gxwvj3IT5cD/PKXyA8Xhmi7LHLm4jBnfh8hKIYQVj1zgGVbj1N64BzFn/5G5b7TiKMhtHAYx0zAnRmYnYY70zAzBTO3C8xOFfq8sRlg1kuNUFRVz0NrdlL12ncUv36Kyv1n8HVdQ7t6lWhPH9HuXuSOLuTOLiJXe4j29BLpdukh1NFFqKOTaO81ou0dqDduIhRXbmBpzQ7W7v2elW+epqL5JJKkYKox9JiKbRiE/H4CokhC01CkINFQCDWsYOk6adsmZVmkTBND0xDqdx2mZuPHVDW0UFT/ORUbDyH6g8hhmWFRxOf3E1YUpGDQIyTLJEwT23FIZzJk83myuRz5sTFMy0LY8MYx1m87wrLaHTxQ2Uj52peRgjLRaMSrPb/fjxpTMQzDq8Ok45DJZDzcukunUl7xu7j1KTzx3EFqGlupeeEQCyq2sqKuGb8U9oSe4O5kF7eoTTc0w0DX9Xs4dzfxhEXVb1FU/TZF1Xt5uHo3y2t3IYVcmYWuG95id4GLEg4jSxIRRUFVVWKxGJqmebJsNlsQLi7fxqKKnSwu287C8u2UPr2bgBTGskzi8TjxuydwQ7VSKazpKZxs1jvx3JO7X1jZxMKKV3iwfAvCo42UrdvjndCVJBImllkg6UpGRJLvteD09uHkcji27c2be8cFYdVLCGVNLCzfjLD8eVY8tYuAJOOYuvfjuKF5ra4T/WeAyIlvifX2oRmGNzaHG34kEkFYsnoTC0pdYRNCSSMr65oZHJURYzaGaWNbFrIsEwoGCcgy/oRBwC0jSUJRlHv5dVPg5ltYsnrzPOGLrKp7lf4Rhc6AjZZwSKf+v2U3j0nLKrTzbn8un67wP6tMPYPwUPg+AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/1c6c877c2d14178a31f0c35525c8612a/e4706/flash_01.avif 230w", "/en/static/1c6c877c2d14178a31f0c35525c8612a/d1af7/flash_01.avif 460w", "/en/static/1c6c877c2d14178a31f0c35525c8612a/19dff/flash_01.avif 702w"],
              "sizes": "(max-width: 702px) 100vw, 702px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/1c6c877c2d14178a31f0c35525c8612a/a0b58/flash_01.webp 230w", "/en/static/1c6c877c2d14178a31f0c35525c8612a/bc10c/flash_01.webp 460w", "/en/static/1c6c877c2d14178a31f0c35525c8612a/de2ca/flash_01.webp 702w"],
              "sizes": "(max-width: 702px) 100vw, 702px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/1c6c877c2d14178a31f0c35525c8612a/81c8e/flash_01.png 230w", "/en/static/1c6c877c2d14178a31f0c35525c8612a/08a84/flash_01.png 460w", "/en/static/1c6c877c2d14178a31f0c35525c8612a/d6331/flash_01.png 702w"],
              "sizes": "(max-width: 702px) 100vw, 702px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/1c6c877c2d14178a31f0c35525c8612a/d6331/flash_01.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "702px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/3014b8d933b6e22629143b2cf9ef7868/d6331/flash_02.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "87.3913043478261%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAAA7CAAAOwgEVKEqAAAAD7klEQVQ4y12TXWwUVRTHpxUJiEgtIO1SCzGRSggRjC+mEUIMSg0FA6aiFYli08RoIBgh0Vj7UtFoouHBGCBAjaEFqYkJkkgRJYgI/dy2u7OzO7s7Mzv7NfvdLa1Y4GfubWnEh1/O3HNy/+fcc84oTfsP8cHnnew52Ml7bR20fN2FFbGJRCLEYjEymQzZXI5UKkWxWGRiYuIexsfHZxgbG0OpXrePDc3fsHzLZ8xf/wnlz7Uy4vXj8Yzg8XjxeDz09w+gqirpdBrHcUgkkuRyObLZ7D0In1K2pplVL33K2neOU9N8gppXDqFqIYxwGNM0sS2TTMph8ubf3JwYp1jIU8hlGb8xxvhYkRtjo1O2OEo+n0NRVu5G2foF97/fhbL3DEvf/Q7LTlAcLRAIGVzpddM7pHJt0INb1VFDNh7dosft5brbS/+INhXzBbHsKMq8uo9Z3HaRRQcv8EDLOZa3nkU3bJxEjAE9zsmeJKf7knx/LcbZkQydA1nae9Kc6k1w+I8onb1Jjv8Z5dg1B68RRymv3cfD276iYu9pFhz4iWXN7aj+IKGgjpNMArfh9iRwa8re/meaSbgjuDUV4w6ZdBplzpJ1zK15jerXD7Ng5zGWNbUTsqLEolFMyyJsGAT0oCQUNqZ9pvzW/AECuk7EtjFMS26GMm9JLWUrX2V10zEWv9FOdeO3+PUwuh4gGo3Jyeq6jqZpJBIJQqGQHJa4LGL/nXY8Hkep3XGQmo37eXTDHh589kOqN7Wg+vyoXi/Dw8NyXcLhsBT0+/0Eg0EpLPZSiBUKBYnY0WQyifJM45c8vb2NspUNlFZtourJ7YTDpqxCiPl8PlmNyC5ERFX5fF5ytzqx/AKRSFm2/gBP1LWy4vmPUFxbqVjdSNi00TQfth2VIncvCDFxFhdFAvEnCStiIoEUnPPYWzxU08T8FW8z9/FdLF61E9OKEgzq9PX1MTg4KKsVzxEtGBoaks8WPtEKy7Jmni4FSxa9zOylO5hd2UCpqwHXmjcxTBs9EOCvq1fp7enBNAxZhfCJNvg1TX6HgkE5JFH56IzgI/XMqtrGLNdWlPJNVD21GyMSI55KEbIiGLZNRPQvlycp+pTOEHMcYqkUMSclz5lCgWyxSMJxUEoqXqSksp5S12aU8o1UrNlF2KuR0bykNVWS8gm8mP29+K9ewXYPkNZ80idwVA9JzzBWICAEN1NaWc99rnqUhS9QsXYXavdlhk6fY/DMLwx1nefy8R+4dPQUFw+f5NLRTn470sHvRzq4cqJLxt0/nsfd+TPG9X4UIVZaIQS3oCysw7W6kX6/za/+DN2+FBem6VZTM+f/W4mWJhCJ8y9ykDW8VjXB8QAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/3014b8d933b6e22629143b2cf9ef7868/e4706/flash_02.avif 230w", "/en/static/3014b8d933b6e22629143b2cf9ef7868/d1af7/flash_02.avif 460w", "/en/static/3014b8d933b6e22629143b2cf9ef7868/19dff/flash_02.avif 702w"],
              "sizes": "(max-width: 702px) 100vw, 702px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/3014b8d933b6e22629143b2cf9ef7868/a0b58/flash_02.webp 230w", "/en/static/3014b8d933b6e22629143b2cf9ef7868/bc10c/flash_02.webp 460w", "/en/static/3014b8d933b6e22629143b2cf9ef7868/de2ca/flash_02.webp 702w"],
              "sizes": "(max-width: 702px) 100vw, 702px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/3014b8d933b6e22629143b2cf9ef7868/81c8e/flash_02.png 230w", "/en/static/3014b8d933b6e22629143b2cf9ef7868/08a84/flash_02.png 460w", "/en/static/3014b8d933b6e22629143b2cf9ef7868/d6331/flash_02.png 702w"],
              "sizes": "(max-width: 702px) 100vw, 702px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/3014b8d933b6e22629143b2cf9ef7868/d6331/flash_02.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h3 {...{
      "id": "running-the-bridge",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#running-the-bridge",
        "aria-label": "running the bridge permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Running the bridge`}</h3>
    <p>{`After flashing your CC2531 USB sniffer with CC2531ZNP-Prod.hex firmware we can remove the CC Debugger and connecting cable and plug the Sniffer into our Linux computer you can use a `}<strong parentName="p">{`Raspberry Pi 3`}</strong>{` with `}<strong parentName="p">{`Raspbian Stretch Lite`}</strong>{`, but will work on any Linux machine. In the example below we used the `}<a parentName="p" {...{
        "href": "https://wiki.instar.com/Software/Linux/MotionEye/"
      }}>{`Core i3 Mini PC with Debian Stretch`}</a>{` that we used to install the Software MotionEye on.`}</p>
    <p>{`For `}<a parentName="p" {...{
        "href": "https://github.com/Koenkk/zigbee2mqtt/wiki/Running-the-bridge"
      }}>{`alternative installation paths`}</a>{` please follow this link.`}</p>
    <p><strong parentName="p">{`NOTE`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/Koenkk/zigbee2mqtt/issues/67#issuecomment-392574987"
      }}>{`it is reported that Raspbian Jessie doesn't work`}</a>{`.`}</p>
    <h4 {...{
      "id": "determine-location-of-cc2531-usb-sniffer-and-checking-user-permissions",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#determine-location-of-cc2531-usb-sniffer-and-checking-user-permissions",
        "aria-label": "determine location of cc2531 usb sniffer and checking user permissions permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Determine location of CC2531 USB sniffer and checking user permissions`}</h4>
    <p>{`We first need to determine the location of the CC2531 USB sniffer. Connect the CC2531 USB to your Raspberry Pi. Most of the times the location of the CC2531 is `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/dev/ttyACM0`}</code>{`. This can be verified by:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`ls`}</span>{` -l /dev/ttyACM0
crw-rw---- `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` root dialout `}<span parentName="code" {...{
            "className": "token number"
          }}>{`166`}</span>{`, `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span>{` May `}<span parentName="code" {...{
            "className": "token number"
          }}>{`16`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`19`}</span>{`:15 /dev/ttyACM0  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# <-- CC2531 on /dev/ttyACM0`}</span></code></pre></div>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/f5bb2a1d26b8df55d5d0ef390eaa43e6/e9beb/zigbee2mqtt_01.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "4.3478260869565215%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAABCAYAAADeko4lAAAACXBIWXMAAA7CAAAOwgEVKEqAAAAAVUlEQVQI1xXDTQpAQACAUYch0hiMFEpmgWL8NdxhFlZWjv/Jq+eZdWA/JqydOa8N12tc13APmseMvMuIbkvyIkKpkKoWyDwiFj5C/gNkFpKkAYn0+QCoNyJEMmKcsgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/f5bb2a1d26b8df55d5d0ef390eaa43e6/e4706/zigbee2mqtt_01.avif 230w", "/en/static/f5bb2a1d26b8df55d5d0ef390eaa43e6/d1af7/zigbee2mqtt_01.avif 460w", "/en/static/f5bb2a1d26b8df55d5d0ef390eaa43e6/b6582/zigbee2mqtt_01.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/f5bb2a1d26b8df55d5d0ef390eaa43e6/a0b58/zigbee2mqtt_01.webp 230w", "/en/static/f5bb2a1d26b8df55d5d0ef390eaa43e6/bc10c/zigbee2mqtt_01.webp 460w", "/en/static/f5bb2a1d26b8df55d5d0ef390eaa43e6/87ca7/zigbee2mqtt_01.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/f5bb2a1d26b8df55d5d0ef390eaa43e6/81c8e/zigbee2mqtt_01.png 230w", "/en/static/f5bb2a1d26b8df55d5d0ef390eaa43e6/08a84/zigbee2mqtt_01.png 460w", "/en/static/f5bb2a1d26b8df55d5d0ef390eaa43e6/e9beb/zigbee2mqtt_01.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/f5bb2a1d26b8df55d5d0ef390eaa43e6/e9beb/zigbee2mqtt_01.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`As an alternative, the device can also be mapped by an ID. This can be handy if you have multiple serial devices connected to your pi. In the example below the device location is: `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/dev/serial/by-id/usb-Texas_Instruments_TI_CC2531_USB_CDC___0X00124B0018E32D5B-if00`}</code></p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`ls`}</span>{` -l /dev/serial/by-id
total `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span>{`
lrwxrwxrwx `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` root root `}<span parentName="code" {...{
            "className": "token number"
          }}>{`13`}</span>{` Nov `}<span parentName="code" {...{
            "className": "token number"
          }}>{`24`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`18`}</span>{`:59 usb-Texas_Instruments_TI_CC2531_USB_CDC___0X00124B0018E32D5B-if00 -`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`..`}</span>{`/`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`..`}</span>{`/ttyACM0`}</code></pre></div>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/da57b41dfb0e48f940130d62bc5b0b42/e9beb/zigbee2mqtt_02.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "7.391304347826087%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAABCAIAAABR8BlyAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAP0lEQVQI1x3CAQqAMAgAwP4TKGkqOjaYK8r/fyjouO2pmavNjJXxdqmhNfRucnVhA1Y0Z4tTnJB2UhA//qgGH63gDV1LDc2jAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/da57b41dfb0e48f940130d62bc5b0b42/e4706/zigbee2mqtt_02.avif 230w", "/en/static/da57b41dfb0e48f940130d62bc5b0b42/d1af7/zigbee2mqtt_02.avif 460w", "/en/static/da57b41dfb0e48f940130d62bc5b0b42/b6582/zigbee2mqtt_02.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/da57b41dfb0e48f940130d62bc5b0b42/a0b58/zigbee2mqtt_02.webp 230w", "/en/static/da57b41dfb0e48f940130d62bc5b0b42/bc10c/zigbee2mqtt_02.webp 460w", "/en/static/da57b41dfb0e48f940130d62bc5b0b42/87ca7/zigbee2mqtt_02.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/da57b41dfb0e48f940130d62bc5b0b42/81c8e/zigbee2mqtt_02.png 230w", "/en/static/da57b41dfb0e48f940130d62bc5b0b42/08a84/zigbee2mqtt_02.png 460w", "/en/static/da57b41dfb0e48f940130d62bc5b0b42/e9beb/zigbee2mqtt_02.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/da57b41dfb0e48f940130d62bc5b0b42/e9beb/zigbee2mqtt_02.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h4 {...{
      "id": "installation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#installation",
        "aria-label": "installation permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Installation`}</h4>
    <p>{`To use ZigBee2MQTT we first need to `}<a parentName="p" {...{
        "href": "/en/Software/Linux/Node-RED/#installing-node-red"
      }}>{`install Node.js`}</a>{` and Git:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`apt`}</span>{` update
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`apt`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`install`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`git`}</span></code></pre></div>
    <p>{`You can confirm that you have installed Git and Node correctly by running the following commands:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`git`}</span>{` --version
node -v`}</code></pre></div>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/72925dbbdf947c7c1c5e5e30826ce3ef/e9beb/zigbee2mqtt_03.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "8.260869565217392%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAACCAYAAABYBvyLAAAACXBIWXMAAA7CAAAOwgEVKEqAAAAAiElEQVQI1yXIywqCQBSAYZ8ldLyMx2PjfbSkoKCFQa2KIGjT+7/BH9Xi23zB5XpiOR/Z7T3P7cDd1zzmntc8cBiUbqzxvsJ3OX2d0rVCOzQ4l1GqQTX+KxN0nRJMm4ZxanBdya1S3k5ZMoO1ESIxRWkRiZA8RMRQaIxois0jMhv+fD8Xg0lWfADh60A566+szgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/72925dbbdf947c7c1c5e5e30826ce3ef/e4706/zigbee2mqtt_03.avif 230w", "/en/static/72925dbbdf947c7c1c5e5e30826ce3ef/d1af7/zigbee2mqtt_03.avif 460w", "/en/static/72925dbbdf947c7c1c5e5e30826ce3ef/b6582/zigbee2mqtt_03.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/72925dbbdf947c7c1c5e5e30826ce3ef/a0b58/zigbee2mqtt_03.webp 230w", "/en/static/72925dbbdf947c7c1c5e5e30826ce3ef/bc10c/zigbee2mqtt_03.webp 460w", "/en/static/72925dbbdf947c7c1c5e5e30826ce3ef/87ca7/zigbee2mqtt_03.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/72925dbbdf947c7c1c5e5e30826ce3ef/81c8e/zigbee2mqtt_03.png 230w", "/en/static/72925dbbdf947c7c1c5e5e30826ce3ef/08a84/zigbee2mqtt_03.png 460w", "/en/static/72925dbbdf947c7c1c5e5e30826ce3ef/e9beb/zigbee2mqtt_03.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/72925dbbdf947c7c1c5e5e30826ce3ef/e9beb/zigbee2mqtt_03.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Then clone `}<a parentName="p" {...{
        "href": "https://github.com/Koenkk/zigbee2mqtt"
      }}>{`ZigBee2MQTT from Github`}</a>{` and change the owner of the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/opt/zigbee2mqtt`}</code>{` directory to your default Linux user - in our case this is `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`nodeadmin`}</code>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`git`}</span>{` clone https://github.com/Koenkk/zigbee2mqtt.git /opt/zigbee2mqtt
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`chown`}</span>{` -R nodeadmin:nodeadmin /opt/zigbee2mqtt`}</code></pre></div>
    <p>{`Then change into the directory and use `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`npm`}</code>{` to install all dependencies:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`cd`}</span>{` /opt/zigbee2mqtt
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`install`}</span></code></pre></div>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/eaa2112bf03df344f7dd7ef477c669a5/e9beb/zigbee2mqtt_04.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "27.39130434782609%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAIAAADKYVtkAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABBElEQVQY0x3NWU6DQAAAUI5iYijDrAwwLIXOwjYLQmn0o1ETvYD+9P6Jie8CL9p3vyx6npQP8/uxfl3D66SvujdFpjjpKQw52nLkBLKCSs5MLfbh8mKkEkVk7dB1Yhgv1pnt8JMb7Dr7bWll03RVStOySJoKFBlgPE5gfCIwZRRkLMEw2v7nxephvNyP8Hlb75s9Fu1Nb9rSqW6Tzdt03mXlKpqTmGGQZwgznCIQhdWGdV5mpcf+w/S/8/DjpscyPvr2m5FAUgNjT0+7gBtPBYoFBpyCMscZg5Eyndad1m1dc6VbO3XByZuXq6rmthA5EQL356wRkKCnDD5XKKEwLjksOfwDAE9F9V07vJMAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/eaa2112bf03df344f7dd7ef477c669a5/e4706/zigbee2mqtt_04.avif 230w", "/en/static/eaa2112bf03df344f7dd7ef477c669a5/d1af7/zigbee2mqtt_04.avif 460w", "/en/static/eaa2112bf03df344f7dd7ef477c669a5/b6582/zigbee2mqtt_04.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/eaa2112bf03df344f7dd7ef477c669a5/a0b58/zigbee2mqtt_04.webp 230w", "/en/static/eaa2112bf03df344f7dd7ef477c669a5/bc10c/zigbee2mqtt_04.webp 460w", "/en/static/eaa2112bf03df344f7dd7ef477c669a5/87ca7/zigbee2mqtt_04.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/eaa2112bf03df344f7dd7ef477c669a5/81c8e/zigbee2mqtt_04.png 230w", "/en/static/eaa2112bf03df344f7dd7ef477c669a5/08a84/zigbee2mqtt_04.png 460w", "/en/static/eaa2112bf03df344f7dd7ef477c669a5/e9beb/zigbee2mqtt_04.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/eaa2112bf03df344f7dd7ef477c669a5/e9beb/zigbee2mqtt_04.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h4 {...{
      "id": "configuration",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#configuration",
        "aria-label": "configuration permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Configuration`}</h4>
    <p>{`Before we can start zigbee2mqtt we need to edit the configuration.yaml file. This file contains the configuration which will be used by zigbee2mqtt. Open the configuration file:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`nano`}</span>{` /opt/zigbee2mqtt/data/configuration.yaml`}</code></pre></div>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/ce28a271b31218022aee18b044945f59/e9beb/zigbee2mqtt_05.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "45.21739130434783%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABjElEQVQoz23N+1LaQBQG8LwCItoqYqdkN7tJ9pYN5IaISaTyFC1TXKSDBJyAvWgHWx/c2dDbH535zZkzZ75vjnFbqPnienl3c1fO778uN5+L+y+LxWp6W1zPPo0nk/dKjZUa38w+KvVhOpuo6Xi1mq/Xy7IsDJu8QU4L2M234HWrvX90Ujs62Ttu1Zun9ePW/uGrnfq/God7jYNa46BmxGcs6rFu5HRDh3KTctOy2ugP3LZtDeP/MNJcBBEKEiQEJK7JKOD8L8YAJYARPYlrVvSuucDIcpkNRf+Cppcyy7px4oYxCiIchKgTQCkhdeGv9G+MQkYgJVB/Ho5kf0CTPo4T4vsWBE2ENEpM6VvSszizOIWMWhXImSWYPhp5Hg8vo2Whnp+/bZ/W2x+bh8fy+7Z8+rnJstCTbd9HvIruOoIhj2uCI6M/YHHkpLm8GiXpIMnTXp71slQvHUkY2aWxJioci6rpCWy8G0XDK//8gqeZSM4cv2N2QyAEoA7wOJbC3nWE7uuOFLhiS4FfAOledCd9bi5NAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/ce28a271b31218022aee18b044945f59/e4706/zigbee2mqtt_05.avif 230w", "/en/static/ce28a271b31218022aee18b044945f59/d1af7/zigbee2mqtt_05.avif 460w", "/en/static/ce28a271b31218022aee18b044945f59/b6582/zigbee2mqtt_05.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/ce28a271b31218022aee18b044945f59/a0b58/zigbee2mqtt_05.webp 230w", "/en/static/ce28a271b31218022aee18b044945f59/bc10c/zigbee2mqtt_05.webp 460w", "/en/static/ce28a271b31218022aee18b044945f59/87ca7/zigbee2mqtt_05.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/ce28a271b31218022aee18b044945f59/81c8e/zigbee2mqtt_05.png 230w", "/en/static/ce28a271b31218022aee18b044945f59/08a84/zigbee2mqtt_05.png 460w", "/en/static/ce28a271b31218022aee18b044945f59/e9beb/zigbee2mqtt_05.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/ce28a271b31218022aee18b044945f59/e9beb/zigbee2mqtt_05.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`We are using a `}<a parentName="p" {...{
        "href": "/en/Software/Linux/Node-RED/#configuring-mosquitto"
      }}>{`local Mosquitto MQTT server`}</a>{` that we already configured with a client login which has to be added here. Also we are planning to use a local installation of `}<a parentName="p" {...{
        "href": "/en/Software/Linux/Home_Assistant/"
      }}>{`Home Assistant`}</a>{` that we want to be able to directly communicate with the ZigBee2MQTT bridge:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "className": "language-yaml"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`# Home Assistant integration (MQTT discovery)`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`homeassistant`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`true`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# allow new devices to join`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`permit_join`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`true`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# MQTT settings`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`mqtt`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# MQTT base topic for zigbee2mqtt MQTT messages`}</span>{`
  `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`base_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` zigbee2mqtt
  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# MQTT server URL - change this to a local IP if you are running you server on a different device`}</span>{`
  `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`server`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'mqtt://localhost'`}</span>{`
  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# MQTT server authentication, uncomment if required:`}</span>{`
  `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`user`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` debian
  `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`password`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` my_password

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# Serial settings`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`serial`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# Location of CC2531 USB sniffer`}</span>{`
  `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`port`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` /dev/ttyACM0`}</code></pre></div>
    <p>{`Make sure that `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`permit_join`}</code>{` is set to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`true`}</code>{`, to allow new devices to be added. It can be set to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`false`}</code>{` once all your Zigbee devices are integrated.`}</p>
    <p>{`For the serial port you can use the `}<a parentName="p" {...{
        "href": "#determine-location-of-cc2531-usb-sniffer-and-checking-user-permissions"
      }}>{`location of CC2531 USB sniffer`}</a>{` that we determined to be either `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/dev/ttyACM0`}</code>{` or `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/dev/serial/by-id/usb-Texas_Instruments_TI_CC2531_USB_CDC___0X00124B0018E32D5B-if00`}</code>{` - both can be used interchangeably (the location might differ in your case!).`}</p>
    <h4 {...{
      "id": "running-zigbee2mqtt",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#running-zigbee2mqtt",
        "aria-label": "running zigbee2mqtt permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Running ZigBee2MQTT`}</h4>
    <p>{`Now that we have setup everything correctly we can start zigbee2mqtt directly from our console to see if there are any error messages:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`cd`}</span>{` /opt/zigbee2mqtt
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` start`}</code></pre></div>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/6d33fe2878897a302da1595941f19829/e9beb/zigbee2mqtt_06.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "41.30434782608695%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABdUlEQVQY0zWP246bMBiEeZRetEmBEGMDPgH27wPGmJN2s6t2b/r+j1ElVaXRSHPzzUy2Lu7cQ5rBQb8lG/wYgO99F2nt23tLyo6ULSka/F+vSOr8cv2WWS2CGwxwUMxoZjV3RirNKEOMIU6R5FgwJFjNKaJtReq8qXOCi3t1ySSvOCsYK0FTZwQoCoraJ4WpoVVDO8hGj50DYTXXivaC9AILiiSrMzejeN5hKr3rzm2KQaVZp8Xsq0sRjs2nCKDo2DdPqBHe9YMgtL3R9pbZWO6flU9FXOSvj2Nb7bH7Y58ex3xu/jzCuU/eiH/9r7dXjK745VmY8OOtSxHHID/e0hL0mswWzab7yFk0gx1pGiUoqscOFDWKSo4anBN0zWAq1vebCT+d797PZQ5qiXpd3Z78Nul9sUtQZngO1ooOPWmbkpAcoWtV/cikvpjlIuH7MNYxAIDwwH+b/k+ALzt8mf5zZAett6ZKTbU21YzyBZehLh51+RcYTXEEkbf6VwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/6d33fe2878897a302da1595941f19829/e4706/zigbee2mqtt_06.avif 230w", "/en/static/6d33fe2878897a302da1595941f19829/d1af7/zigbee2mqtt_06.avif 460w", "/en/static/6d33fe2878897a302da1595941f19829/b6582/zigbee2mqtt_06.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/6d33fe2878897a302da1595941f19829/a0b58/zigbee2mqtt_06.webp 230w", "/en/static/6d33fe2878897a302da1595941f19829/bc10c/zigbee2mqtt_06.webp 460w", "/en/static/6d33fe2878897a302da1595941f19829/87ca7/zigbee2mqtt_06.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/6d33fe2878897a302da1595941f19829/81c8e/zigbee2mqtt_06.png 230w", "/en/static/6d33fe2878897a302da1595941f19829/08a84/zigbee2mqtt_06.png 460w", "/en/static/6d33fe2878897a302da1595941f19829/e9beb/zigbee2mqtt_06.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/6d33fe2878897a302da1595941f19829/e9beb/zigbee2mqtt_06.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`You can see that the service is running, connected to the local MQTT server and published a message to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`zigbee2mqtt/bridge/state`}</code>{` with the payload `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`online`}</code>{`. We can use the program `}<a parentName="p" {...{
        "href": "/en/Advanced_User/OpenHAB_Home_Automation/Mosquitto_Installation_on_Windows/#testing-the-mqtt-server-with-mqttfx"
      }}>{`MQTT.fx`}</a>{` to verify that the message was received by our Mosquitto server:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/2667d899a41157b476e6f6af14b664a3/e9beb/zigbee2mqtt_07.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.52173913043479%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABpklEQVQoz4XOW2sTQRTA8fk2NnuZ25mdvdXdDUk3Rs0mYRORGqG0MZcSjUiDoKlUMVHIsptsRXzwoeIXlawaCq344/9yZs7DQatVlm/W+TpN0zT7Lc2y9Sbb5Ot1Md0mSZI0TRAxPTBdZpcxZQRjgjEmhFk+dwLP923HKR628BbBhGiqKgTYdxmqhdXGk1F0uojix1H0MI7jMKwZ0qKMY13VNQX/jTJKCSa6ZliuYTpY11E/ag47neOocdJs9dvtfqs17D569vLd0fTt0fBFfzI7mZwVzUZnF+NXb0bT188v8sn5ajSdobZp1Sy76Qdx5aDhOvUwPj4cL5b5fPX1Q/p9eflj1yK/WlxeLb/8PP+UzD++X6bfkMmYxZjNuQPgALgAkjJNUzVVUZU9pXTnWn9GVSmpSkkp7SEuxDaAXSCElNLYkob8R8UXghtEAf5HACBxAwjBOYciUSzdGqEUBeUtKSUA+L5vu24YVA8rYTsox0H5niErjFc5XO+AQ0UYAz9AvLA7BlNS98rzwemg1xv3nnbr9/cp9TjftU/5A8/stMLP7e4vKQ679r+DEYQAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/2667d899a41157b476e6f6af14b664a3/e4706/zigbee2mqtt_07.avif 230w", "/en/static/2667d899a41157b476e6f6af14b664a3/d1af7/zigbee2mqtt_07.avif 460w", "/en/static/2667d899a41157b476e6f6af14b664a3/b6582/zigbee2mqtt_07.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/2667d899a41157b476e6f6af14b664a3/a0b58/zigbee2mqtt_07.webp 230w", "/en/static/2667d899a41157b476e6f6af14b664a3/bc10c/zigbee2mqtt_07.webp 460w", "/en/static/2667d899a41157b476e6f6af14b664a3/87ca7/zigbee2mqtt_07.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/2667d899a41157b476e6f6af14b664a3/81c8e/zigbee2mqtt_07.png 230w", "/en/static/2667d899a41157b476e6f6af14b664a3/08a84/zigbee2mqtt_07.png 460w", "/en/static/2667d899a41157b476e6f6af14b664a3/e9beb/zigbee2mqtt_07.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/2667d899a41157b476e6f6af14b664a3/e9beb/zigbee2mqtt_07.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h4 {...{
      "id": "running-zigbee2mqtt-as-a-daemon",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#running-zigbee2mqtt-as-a-daemon",
        "aria-label": "running zigbee2mqtt as a daemon permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Running ZigBee2MQTT as a Daemon`}</h4>
    <p>{`To run zigbee2mqtt as a service and start it automatically on boot we will run zigbee2mqtt with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`systemctl`}</code>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`nano`}</span>{` /etc/systemd/system/zigbee2mqtt.service`}</code></pre></div>
    <p>{`Add the following to this file to automatically run the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`index.js`}</code>{` file from the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`zigbee2mqtt`}</code>{` bridge inside the Node runtime:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "className": "language-text"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`[Unit]
Description=zigbee2mqtt
After=network.target

[Service]
ExecStart=/usr/bin/node /opt/zigbee2mqtt/index.js
StandardOutput=syslog
StandardError=syslog
SyslogIdentifier=zigbee2mqtt
Restart=always
 # Restart service after 10 seconds if node service crashes
 RestartSec=10

[Install]
WantedBy=multi-user.target`}</code></pre></div>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/3052f8d05bfe68edc4b868e9ca2c5fc2/e9beb/zigbee2mqtt_08.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "36.08695652173913%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAIAAACHqfpvAAAACXBIWXMAAA7DAAAOwwHHb6hkAAABcElEQVQY0yWMbU+yUACGj8sUClQgtdmenvUyLA4g5x04R0Wd9KZuhpGtVv3/X9Go7fpwf7ivC+TfX2n5Icv37P3z7vNLlvtkt0+KUpZlXOzQpmDbXbR+DlfbcLVFm4JsivTlLdm9yqIEF/O7U5WfqeVALU0yBi4GLqoNseazukeaPtUD0YDs0OMHt7R2Q2o31QG4UcXl4uk8u7d4ZovZicgsNuknszM578aZwyc2VQ5VPSEdPrGwamNpRokZCiMQesCBLN/o8z542kbrYpivTuIq0YunBkqNKNFHSd2jTUiOQm4ioYW8AZkGmREwzafg9n7tLh/d/HGQZufjeTeetci4g2X7F5vIv930eQPS45AZo0rTAlqHFFxl+f/pcqDmHSr7QrawMlDaxtIi4xaWfaocLC2U6JA2PKL7rPKrBD/GElwvHv5lDzafWmzaSxcmSmtDdADpIWRNj1g4dpDojKgZEh0SK2JtxG1Eu5jafPIDRo1NMxjgBz4AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/3052f8d05bfe68edc4b868e9ca2c5fc2/e4706/zigbee2mqtt_08.avif 230w", "/en/static/3052f8d05bfe68edc4b868e9ca2c5fc2/d1af7/zigbee2mqtt_08.avif 460w", "/en/static/3052f8d05bfe68edc4b868e9ca2c5fc2/b6582/zigbee2mqtt_08.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/3052f8d05bfe68edc4b868e9ca2c5fc2/a0b58/zigbee2mqtt_08.webp 230w", "/en/static/3052f8d05bfe68edc4b868e9ca2c5fc2/bc10c/zigbee2mqtt_08.webp 460w", "/en/static/3052f8d05bfe68edc4b868e9ca2c5fc2/87ca7/zigbee2mqtt_08.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/3052f8d05bfe68edc4b868e9ca2c5fc2/81c8e/zigbee2mqtt_08.png 230w", "/en/static/3052f8d05bfe68edc4b868e9ca2c5fc2/08a84/zigbee2mqtt_08.png 460w", "/en/static/3052f8d05bfe68edc4b868e9ca2c5fc2/e9beb/zigbee2mqtt_08.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/3052f8d05bfe68edc4b868e9ca2c5fc2/e9beb/zigbee2mqtt_08.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Save the file, exit and verify that the configuration works:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` systemctl daemon-reload
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` systemctl start zigbee2mqtt
systemctl status zigbee2mqtt.service`}</code></pre></div>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/eee576bb53f07f08220a444fca262a45/e9beb/zigbee2mqtt_09.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "22.17391304347826%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAIAAAABPYjBAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAzklEQVQI1xXESXKEIAAAQL+iOCZRFlOCgAoColgCs11yyf/fkUofukj3kB9XTGHzxtr5DDY/Y3LqPY3XOmUtX0b+HPr3co+Vx6EbIcC47jHACBTayBCccdI4rla6nyrdj8PP0cq4zZcVl+HZT8+gk5NBU0oR6dtJEsZgsazCbPNimA+z3YVcCBeYCyKmb8YhHSFlkLKOsm4YWoTrj6+qupVtWzWfZSEWqlbudhWT3w+ds0/Zx7CcXijFpCBSkJ40CAKMagTruinBrfy/Kf8Aekg2HV/HZhYAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/eee576bb53f07f08220a444fca262a45/e4706/zigbee2mqtt_09.avif 230w", "/en/static/eee576bb53f07f08220a444fca262a45/d1af7/zigbee2mqtt_09.avif 460w", "/en/static/eee576bb53f07f08220a444fca262a45/b6582/zigbee2mqtt_09.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/eee576bb53f07f08220a444fca262a45/a0b58/zigbee2mqtt_09.webp 230w", "/en/static/eee576bb53f07f08220a444fca262a45/bc10c/zigbee2mqtt_09.webp 460w", "/en/static/eee576bb53f07f08220a444fca262a45/87ca7/zigbee2mqtt_09.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/eee576bb53f07f08220a444fca262a45/81c8e/zigbee2mqtt_09.png 230w", "/en/static/eee576bb53f07f08220a444fca262a45/08a84/zigbee2mqtt_09.png 460w", "/en/static/eee576bb53f07f08220a444fca262a45/e9beb/zigbee2mqtt_09.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/eee576bb53f07f08220a444fca262a45/e9beb/zigbee2mqtt_09.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Now that everything works, we want `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`systemctl`}</code>{` to start `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`zigbee2mqtt`}</code>{` automatically on boot, this can be done by executing:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "className": "language-text"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`sudo systemctl enable zigbee2mqtt.service`}</code></pre></div>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/d811ef0cfaea7a75df275a5267b90af5/e9beb/zigbee2mqtt_10.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "7.391304347826087%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAABCAIAAABR8BlyAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAARUlEQVQI12MIjwgJDvH39fP08HTx9nHz9fcO8nP3s7dwtTLztLX0sLX0d3HwdbT1sLFwMDMyMdE3szAxtzAxMNQJiwgBAP6OD8K0nZxcAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/d811ef0cfaea7a75df275a5267b90af5/e4706/zigbee2mqtt_10.avif 230w", "/en/static/d811ef0cfaea7a75df275a5267b90af5/d1af7/zigbee2mqtt_10.avif 460w", "/en/static/d811ef0cfaea7a75df275a5267b90af5/b6582/zigbee2mqtt_10.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/d811ef0cfaea7a75df275a5267b90af5/a0b58/zigbee2mqtt_10.webp 230w", "/en/static/d811ef0cfaea7a75df275a5267b90af5/bc10c/zigbee2mqtt_10.webp 460w", "/en/static/d811ef0cfaea7a75df275a5267b90af5/87ca7/zigbee2mqtt_10.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/d811ef0cfaea7a75df275a5267b90af5/81c8e/zigbee2mqtt_10.png 230w", "/en/static/d811ef0cfaea7a75df275a5267b90af5/08a84/zigbee2mqtt_10.png 460w", "/en/static/d811ef0cfaea7a75df275a5267b90af5/e9beb/zigbee2mqtt_10.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/d811ef0cfaea7a75df275a5267b90af5/e9beb/zigbee2mqtt_10.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Some tips that can be handy later:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`# Stopping zigbee2mqtt`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` systemctl stop zigbee2mqtt

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# Starting zigbee2mqtt`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` systemctl start zigbee2mqtt

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# View the log of zigbee2mqtt`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` journalctl -u zigbee2mqtt.service -f`}</code></pre></div>
    <h4 {...{
      "id": "update-zigbee2mqtt-to-the-latest-version",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#update-zigbee2mqtt-to-the-latest-version",
        "aria-label": "update zigbee2mqtt to the latest version permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Update zigbee2mqtt to the latest version`}</h4>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`# Stop zigbee2mqtt and go to directory`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` systemctl stop zigbee2mqtt
`}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`cd`}</span>{` /opt/zigbee2mqtt

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# Backup configuration`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`cp`}</span>{` -R data data-backup

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# Update`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`git`}</span>{` checkout HEAD -- npm-shrinkwrap.json
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`git`}</span>{` pull
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`rm`}</span>{` -rf node_modules
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`install`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# Restore configuration`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`cp`}</span>{` -R data-backup/* data
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`rm`}</span>{` -rf data-backup

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# Start zigbee2mqtt`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`sudo`}</span>{` systemctl start zigbee2mqtt`}</code></pre></div>
    <h3 {...{
      "id": "pairing-devices",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#pairing-devices",
        "aria-label": "pairing devices permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Pairing Devices`}</h3>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://github.com/Koenkk/zigbee2mqtt/wiki/Supported-devices"
      }}>{`number of devices that you can use with the zigbee2mqtt bridge`}</a>{` is steadily growing (there are alternative `}<a parentName="p" {...{
        "href": "https://github.com/Koenkk/zigbee2mqtt/wiki/Pairing-devices"
      }}>{`pairing instructions available here`}</a>{`). In this tutorial we are going to add 3 `}<a parentName="p" {...{
        "href": "https://xiaomi-mi.com/sockets-and-sensors/"
      }}>{`XiaoMi Mi Home`}</a>{` sensors - a `}<a parentName="p" {...{
        "href": "https://xiaomi-mi.com/sockets-and-sensors/xiaomi-mi-temperature-humidity-sensor/"
      }}>{`Temperature & Humidity Sensor`}</a>{`, a `}<a parentName="p" {...{
        "href": "https://xiaomi-mi.com/sockets-and-sensors/xiaomi-mi-wireless-switch/"
      }}>{`Wireless Switch`}</a>{` and a `}<a parentName="p" {...{
        "href": "https://xiaomi-mi.com/sockets-and-sensors/xiaomi-mi-occupancy-sensor/"
      }}>{`Home Occupancy Sensor`}</a>{`.`}</p>
    <p><strong parentName="p">{`IMPORTANT`}</strong>{`: Before you start, make sure that `}<a parentName="p" {...{
        "href": "#configuration"
      }}>{`permit_join: true`}</a>{` is set in your configuration.yaml. Otherwise new devices cannot join the network! Also verify that the `}<a parentName="p" {...{
        "href": "#running-zigbee2mqtt-as-a-daemon"
      }}>{`ZigBee2MQTT Bridge is running`}</a>{`.`}</p>
    <p>{`We first start with the `}<strong parentName="p">{`Temperature & Humidity Sensor`}</strong>{` that has a pairing button on its side. Press the button for about 5 seconds - the `}<strong parentName="p">{`blue LED will start to blink`}</strong>{`: in my case it started to blink slowly in 3-time sequences. After a few seconds the blinking sped up and stopped and the device was paired with the ZigBee Bridge.`}</p>
    <p>{`The pairing can be found inside a log file in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/opt/zigbee2mqtt/data/log/`}</code>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "className": "language-yaml"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}><span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Connecting with device`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`...`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/bridge/log'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"type":"pairing","message":"connecting with device"}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Device incoming`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`...`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/bridge/log'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"type":"pairing","message":"device incoming"}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` New device with address 0x00158d00023a21c8 connected`}<span parentName="code" {...{
            "className": "token tag"
          }}>{`!`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/bridge/log'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"type":"device_connected","message":"0x00158d00023a21c8"}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'homeassistant/sensor/0x00158d00023a21c8/temperature/config'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"unit_of_measurement":"Â°C","device_class":"temperature","value_template":"{{ value_json.temperature }}","json_attributes":["linkquality","battery","voltage"],"state_topic":"zigbee2mqtt/0x00158d00023a21c8","availability_topic":"zigbee2mqtt/bridge/state","name":"0x00158d00023a21c8_temperature","unique_id":"0x00158d00023a21c8_temperature_zigbee2mqtt"}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'homeassistant/sensor/0x00158d00023a21c8/humidity/config'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"unit_of_measurement":"%","device_class":"humidity","value_template":"{{ value_json.humidity }}","json_attributes":["linkquality","battery","voltage"],"state_topic":"zigbee2mqtt/0x00158d00023a21c8","availability_topic":"zigbee2mqtt/bridge/state","name":"0x00158d00023a21c8_humidity","unique_id":"0x00158d00023a21c8_humidity_zigbee2mqtt"}'`}</span></code></pre></div>
    <p>{`Shortly afterwards the sensor data started coming in:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "className": "language-yaml"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}><span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/0x00158d00023a21c8'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"temperature":26.74,"linkquality":55,"humidity":54.1,"battery":100,"voltage":3035}'`}</span></code></pre></div>
    <p>{`So far so good. But the `}<strong parentName="p">{`device ID`}</strong>{` was a bit hard to read and memorize: `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`0x00158d00023a21c8`}</code>{`. Luckily this can be adjusted in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/opt/zigbee2mqtt/data/configuration.yaml`}</code>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "className": "language-yaml"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}><span parentName="code" {...{
            "className": "token key atrule"
          }}>{`devices`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
  `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`'0x00158d00023a21c8'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`friendly_name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'temp_hum_sensor'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`retain`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span></code></pre></div>
    <p>{`All paired devices will be listed at the bottom of the configuration file - just change the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`friendly_name`}</code>{` to something human-readable. Remember that this will also change the MQTT topic the Zigbee bridge is using to publish the sensor readouts:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "className": "language-yaml"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}><span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/temp_hum_sensor'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"temperature":26.33,"linkquality":78,"humidity":54.32,"battery":99,"voltage":3005}'`}</span></code></pre></div>
    <p>{`The topic changed from `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`zigbee2mqtt/0x00158d00023a21c8`}</code>{` to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`zigbee2mqtt/temp_hum_sensor`}</code>{` !`}</p>
    <p>{`But pairing both the `}<strong parentName="p">{`Wireless Switch`}</strong>{` and `}<strong parentName="p">{`Home Occupancy Sensor`}</strong>{` turned out to be more difficult. Holding the pairing button - that here could only be reached with a metal pin - gave the same pattern. The `}<strong parentName="p">{`blue LED started flashing`}</strong>{` - first slowly, then fast. But I kept getting timeouts for both devices - that identified as `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`0x00158d00023d229c`}</code>{` and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`0x00158d00020b3dff`}</code>{` - for the pairing process inside the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/opt/zigbee2mqtt/data/log/`}</code></p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "className": "language-yaml"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}><span parentName="code" {...{
            "className": "token key atrule"
          }}>{`error`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`Cannot get the Node Descriptor of the Device`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`0x00158d00023d229c (Error`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Timed out after 10000 ms)
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`error`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`Cannot get the Node Descriptor of the Device`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`0x00158d00020b3dff (Error`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Timed out after 10000 ms)`}</code></pre></div>
    <p>{`You can `}<a parentName="p" {...{
        "href": "https://github.com/Koenkk/zigbee2mqtt/wiki/Pairing-devices#xiaomi"
      }}>{`find an instruction`}</a>{` that you need to press and hold the pairing button for 5 seconds (until the blue LED starts flashing), then release and keep pressing the button repeatedly (1s interval) afterwards - which feels a little bit counter-intuitive. But it actually works. Checking the log file shows that a `}<strong parentName="p">{`Occupancy Sensor`}</strong>{` with the ID `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`0x00158d00020b3dff`}</code>{` was connected:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "className": "language-yaml"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}><span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` New device with address 0x00158d00020b3dff connected`}<span parentName="code" {...{
            "className": "token tag"
          }}>{`!`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/bridge/log'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"type":"device_connected","message":"0x00158d00020b3dff"}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'homeassistant/binary_sensor/0x00158d00020b3dff/occupancy/config'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"payload_on":true,"payload_off":false,"value_template":"{{ value_json.occupancy }}","device_class":"motion","json_attributes":["linkquality","battery","voltage"],"state_topic":"zigbee2mqtt/0x00158d00020b3dff","availability_topic":"zigbee2mqtt/bridge/state","name":"0x00158d00020b3dff","unique_id":"0x00158d00020b3dff_occupancy_zigbee2mqtt"}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/0x00158d00020b3dff'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"occupancy":true,"linkquality":131}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Device incoming`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`...`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/bridge/log'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"type":"pairing","message":"device incoming"}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/0x00158d00020b3dff'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"occupancy":true,"linkquality":128}'`}</span></code></pre></div>
    <p>{`Repeating the same for the `}<strong parentName="p">{`Wireless Switch`}</strong>{` and a new device with ID `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`0x00158d00023d229c`}</code>{` showed up - excellent!`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "className": "language-yaml"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}><span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` New device with address 0x00158d00023d229c connected`}<span parentName="code" {...{
            "className": "token tag"
          }}>{`!`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/bridge/log'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"type":"device_connected","message":"0x00158d00023d229c"}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'homeassistant/sensor/0x00158d00023d229c/click/config'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"icon":"mdi:toggle-switch","value_template":"{{ value_json.click }}","json_attributes":["linkquality","battery","voltage","action","duration"],"force_update":true,"state_topic":"zigbee2mqtt/0x00158d00023d229c","availability_topic":"zigbee2mqtt/bridge/state","name":"0x00158d00023d229c","unique_id":"0x00158d00023d229c_click_zigbee2mqtt"}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Device incoming`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`...`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/bridge/log'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"type":"pairing","message":"device incoming"}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/0x00158d00020b3dff'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"occupancy":false,"linkquality":128}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/0x00158d00023d229c'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"click":"single","linkquality":94}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/0x00158d00023d229c'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"click":"double","linkquality":120}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/0x00158d00023d229c'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"click":"triple","linkquality":120}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/0x00158d00023d229c'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"click":"quadruple","linkquality":115}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/0x00158d00023d229c'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"click":"long","linkquality":118}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/0x00158d00023d229c'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"click":"long_release","duration":1236,"linkquality":118}'`}</span></code></pre></div>
    <p>{` Again, we can adjust that a human-readable name is displayed instead of the ID in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/opt/zigbee2mqtt/data/configuration.yaml`}</code>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "className": "language-yaml"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}><span parentName="code" {...{
            "className": "token key atrule"
          }}>{`devices`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
  `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`'0x00158d00023a21c8'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`friendly_name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'temp_hum_sensor'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`retain`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`'0x00158d00020b3dff'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`friendly_name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'motion_pir_sensor'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`retain`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`'0x00158d00023d229c'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`friendly_name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'smart_button'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`retain`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span></code></pre></div>
    <p>{`The new names will now be used for the corresponding MQTT topics:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "className": "language-yaml"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}><span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/motion_pir_sensor'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"occupancy":true,"linkquality":94,"battery":99,"voltage":3025}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/temp_hum_sensor'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"temperature":27.79,"linkquality":110,"humidity":55.92,"battery":99,"voltage":3005}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/smart_button'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"battery":100,"voltage":3042,"linkquality":68,"click":"single"}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/smart_button'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"battery":100,"voltage":3042,"linkquality":60,"click":"double"}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/smart_button'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"battery":100,"voltage":3042,"linkquality":63,"click":"triple"}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/smart_button'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"battery":100,"voltage":3042,"linkquality":57,"click":"quadruple"}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/smart_button'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"battery":100,"voltage":3042,"linkquality":57,"click":"long"}'`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`info`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` MQTT publish`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'zigbee2mqtt/smart_button'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"battery":100,"voltage":3042,"linkquality":65,"click":"long_release","duration":1015}'`}</span></code></pre></div>
    <p>{`Note that the `}<strong parentName="p">{`Occupancy Sensor`}</strong>{` sends a `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`true`}</code>{` or `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`false`}</code>{` payload depending on if motion was detected or not. The `}<strong parentName="p">{`Temperature & Humidity Sensor`}</strong>{` just sends number values for temperature and humidity. And the `}<strong parentName="p">{`Wireless Button`}</strong>{` sends click events and can discern between `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`single`}</code>{`, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`double`}</code>{`, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`triple`}</code>{`, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`quadruple`}</code>{` and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`long / long_release`}</code>{` clicks.`}</p>
    <h2 {...{
      "id": "using-zigbee-devices-to-control-instar-ip-cameras-in-node-red",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#using-zigbee-devices-to-control-instar-ip-cameras-in-node-red",
        "aria-label": "using zigbee devices to control instar ip cameras in node red permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Using Zigbee Devices to control INSTAR IP Cameras in Node-RED`}</h2>
    <p>{`We now set up the Zigbee Bridge, connected Zigbee sensors and made sure that the messages are send to our Mosquitto MQTT server. We also found out the topics that our bridge uses for each sensors to publish its messages - `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`zigbee2mqtt/motion_pir_sensor`}</code>{`, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`zigbee2mqtt/temp_hum_sensor`}</code>{` and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`zigbee2mqtt/smart_button`}</code>{` - and what kind of payload to expect.`}</p>
    <p>{`Now we can use the program `}<a parentName="p" {...{
        "href": "/en/Advanced_User/OpenHAB_Home_Automation/Mosquitto_Installation_on_Windows/#testing-the-mqtt-server-with-mqttfx"
      }}>{`MQTT.fx`}</a>{` to verify that the message was received by our Mosquitto server:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/c314dbe9d239fa241287b1b9ec7db8c4/e9beb/zigbee2mqtt_11.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "58.69565217391304%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAIAAADtbgqsAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACL0lEQVQoz23R70/TQBgH8P4xJia+cnftej/aXq90Xd0EEkhUWMGQmOEi4gvfYAigwmRsvGCbP9oiw7kZBBdBjFu3OQFDfId/kykQSdBPvrnnySX35C4nNJvNXq/X7XY7nXbnXLvTDgVB0PmfIAi+hVoC0XSKEUJIlpEcikaxivv6VW7acQtjLIqidFlU1VRuRQXDHrDuLZm37uuaYsZifaapKKokIykaThIvQAgBhFCEEESuiyKMyqKQSjmj4xOjzt1UKuU4zpgzEk/0sxvDRGUYIXIGY0XTuZXkOtMNs398Oj54W9OYwJhmGDyZTBicsz7LGEw9mV0srpUKhUK5XPY8zz3nua4fFs9z/fVqtVYsFgVNUznnVjzOOVd5TBsYW8iublYqruttbFQ+1C/UavVaPUy1Wm00Gr7vCzpjpmkODQ3HYqZhJc07Dxayq+ue+/pl2ffcd5uVf1PZeLuz/dFzXQEAIIqiqqqUUqoySI35lTefgl/vd79vN4+/Hv3ePzy5lC8HJ62fJ5v1LSESiQAAIqcAANeuXpldXN7Z71a397Z2W3vto73g8FI+tw6CH8evXF/QdZ0QAiEkhDDGJJlMPXq8nF18Oj+39PxZYSVXyOfC9W+Tz+VzL0qltZmZGQEhJEkSAECSJFmWIRRHnImph9PpdDo9OWnbNkKYKgqlCiGU0rBBGCeSyUwmE74ZgPD3T2t4c8u+adu2eYoxRghRwsMUY6woCsaYUnq2/wc3US2dNuSUPwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/c314dbe9d239fa241287b1b9ec7db8c4/e4706/zigbee2mqtt_11.avif 230w", "/en/static/c314dbe9d239fa241287b1b9ec7db8c4/d1af7/zigbee2mqtt_11.avif 460w", "/en/static/c314dbe9d239fa241287b1b9ec7db8c4/b6582/zigbee2mqtt_11.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/c314dbe9d239fa241287b1b9ec7db8c4/a0b58/zigbee2mqtt_11.webp 230w", "/en/static/c314dbe9d239fa241287b1b9ec7db8c4/bc10c/zigbee2mqtt_11.webp 460w", "/en/static/c314dbe9d239fa241287b1b9ec7db8c4/87ca7/zigbee2mqtt_11.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/c314dbe9d239fa241287b1b9ec7db8c4/81c8e/zigbee2mqtt_11.png 230w", "/en/static/c314dbe9d239fa241287b1b9ec7db8c4/08a84/zigbee2mqtt_11.png 460w", "/en/static/c314dbe9d239fa241287b1b9ec7db8c4/e9beb/zigbee2mqtt_11.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/c314dbe9d239fa241287b1b9ec7db8c4/e9beb/zigbee2mqtt_11.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Every time the state changes the sensor will send a Zigbee message to our Bridge, which then forwards its payload to our Mosquitto server - perfect!`}</p>
    <p>{`We can now start our `}<a parentName="p" {...{
        "href": "https://nodered.org/"
      }}>{`Node-RED`}</a>{` - that we either installed under `}<a parentName="p" {...{
        "href": "/en/Advanced_User/Node-RED_and_MQTT/"
      }}>{`Windows 10`}</a>{`, on a `}<a parentName="p" {...{
        "href": "/en/Advanced_User/openHABian_on_Raspberry_Pi/Node-RED_Setup/"
      }}>{`Raspberry Pi`}</a>{` or a `}<a parentName="p" {...{
        "href": "/en/Software/Linux/Node-RED/"
      }}>{`Debian Linux Server`}</a>{`, add `}<strong parentName="p">{`MQTT Nodes`}</strong>{` and subscribe to all 3 MQTT topics:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/f416239901b8978344c8cd25d51d8a36/e9beb/zigbee2mqtt_12.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "46.52173913043478%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAB2ElEQVQoz02NXWvTUACG87tEVPxDA29brOBoZK5JziwOQfFiDD8vNlct/YhN068tzcdppDdixSHVjmbNaZqkOSc550jnTR+em/fi4RXu3rt/6/adBzs7L8plIMmSrJQkWVJASQaSAiQZ7N9M5eDZtrKsKAAIpf2niiQ92dt7vLv7sFDI5/O5XO5RoSCKYrFYFEVRlmUAgLINAOVXLw8OnwtDwzDNoTuCEELXdSGEjuOMx2N/4a+CIAxDjEm6RUYpWa8nr4//6n2hqemVRqumdbS2bhiG4ziWZUEI53NvNruaTqfXnrdcIuT7yF9sRL7veT8+fbk8NwStWvt89Lb65oOuaaZpOrZtWZbrur7ve/O5d70I4iTGJCYpYZwwjkm6TjDlHGMitNuNWvVjvX7S0TcxhNC27ZsYxes1T7PFz8ur75P55NdqOgt//0liHCVpinGKsaAPunW92WirvUHfsm24uTbdEVwiFCeYhdFqaAaWHZh2YNmRYdIoZJwzxgghQrfVVc+aaq1tn1a+vXuv1xrqaaXbUIPlEieYc55xTjnPGGN8A2OMUso538T9nqp9PdFaZ8NexxmcW6ZpXVyMHAchFEYRYywKwwChVRBkaUqzjFKaZdn/53/7hK+dbcxqCwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/f416239901b8978344c8cd25d51d8a36/e4706/zigbee2mqtt_12.avif 230w", "/en/static/f416239901b8978344c8cd25d51d8a36/d1af7/zigbee2mqtt_12.avif 460w", "/en/static/f416239901b8978344c8cd25d51d8a36/b6582/zigbee2mqtt_12.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/f416239901b8978344c8cd25d51d8a36/a0b58/zigbee2mqtt_12.webp 230w", "/en/static/f416239901b8978344c8cd25d51d8a36/bc10c/zigbee2mqtt_12.webp 460w", "/en/static/f416239901b8978344c8cd25d51d8a36/87ca7/zigbee2mqtt_12.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/f416239901b8978344c8cd25d51d8a36/81c8e/zigbee2mqtt_12.png 230w", "/en/static/f416239901b8978344c8cd25d51d8a36/08a84/zigbee2mqtt_12.png 460w", "/en/static/f416239901b8978344c8cd25d51d8a36/e9beb/zigbee2mqtt_12.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/f416239901b8978344c8cd25d51d8a36/e9beb/zigbee2mqtt_12.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Connect all 3 of them to a `}<strong parentName="p">{`Debug Node`}</strong>{` and deploy the flow. Click the button, warm up the temp sensor and trigger the motion detection - the MQTT messages will show up in the debug pane in Node-RED:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/aead1045e92e40bcf658769448eaed19/e9beb/zigbee2mqtt_13.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "31.304347826086953%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABRklEQVQY01WP0WrbMBSG/f7v0RcYg17uYjBoWZd4q5Olnj1S3DWzE9mSLEuWZH0jHoz1h4//nJuPczI1KNrXlu7UITqB1ppxNCvGTGilEFIijcHFiA2BaZqYzISJEXF3z3mz5XffIy6C7LlqOHw+UOcVzVODnSZSDCzeQYoMUnIqClRZ0n8/0Fc1vRBoKZlDwCuFU2qdtR7Jnn82PG1KjrsjTdlw7lo+Pdzy/sMNH+/fUR9/0G1y1MMXdJ4zVhW677FSEp0jer928h7nHFldHnm8K6i/1rRNy+xnwmxxVhO8RWlN9+0Rtdujih2661CXC1bpv7J5/oe1lkwqjbxIjDR450kpkRIsiTXXV/pix7DZIrc5cr9HCoEZhlWyhLCKr70K+S9X2bIsKzHGdbfOoV9+4V5PzG3LfD7jtGYeR4K1by6cxpE/1a3HCXfM83MAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/aead1045e92e40bcf658769448eaed19/e4706/zigbee2mqtt_13.avif 230w", "/en/static/aead1045e92e40bcf658769448eaed19/d1af7/zigbee2mqtt_13.avif 460w", "/en/static/aead1045e92e40bcf658769448eaed19/b6582/zigbee2mqtt_13.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/aead1045e92e40bcf658769448eaed19/a0b58/zigbee2mqtt_13.webp 230w", "/en/static/aead1045e92e40bcf658769448eaed19/bc10c/zigbee2mqtt_13.webp 460w", "/en/static/aead1045e92e40bcf658769448eaed19/87ca7/zigbee2mqtt_13.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/aead1045e92e40bcf658769448eaed19/81c8e/zigbee2mqtt_13.png 230w", "/en/static/aead1045e92e40bcf658769448eaed19/08a84/zigbee2mqtt_13.png 460w", "/en/static/aead1045e92e40bcf658769448eaed19/e9beb/zigbee2mqtt_13.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/aead1045e92e40bcf658769448eaed19/e9beb/zigbee2mqtt_13.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h3 {...{
      "id": "add-the-mqtt-input-to-an-existing-flow",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#add-the-mqtt-input-to-an-existing-flow",
        "aria-label": "add the mqtt input to an existing flow permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Add the MQTT input to an existing Flow`}</h3>
    <p>{`In the following sequence we are using the input for the wireless button to switch `}<strong parentName="p">{`Alarm Areas`}</strong>{` on our cameras - we already used the same sequence for the `}<a parentName="p" {...{
        "href": "/en/Advanced_User/Alexa_Voice_Control_without_Cloud/"
      }}>{`Amazon Alexa Integration`}</a>{` (the complete flow can be found in the `}<a parentName="p" {...{
        "href": "/en/Software/Linux/Home_Assistant/"
      }}>{`Home Assistant Tutorial`}</a>{`):`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/0237120bb455f5c518eba4d807e96bbe/e9beb/zigbee2mqtt_14.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "35.65217391304348%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAIAAACHqfpvAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABcElEQVQY0yWMUW/aMBRG8/+fK03qWzu1fZgmbWvVTkwtmrqFlkJImFZGYQQTTOyEhMQJoeb6Xk90n47Oy5E+Z5P5KvPqvL9V00KWCZNpnDfBr1e3U7sPyvOKzof66aoefC6fzqpBS3Q68vGn9noF504YvLv0bo7a5z8mj2uxXs1jlVW827s4vbj99LW8b23ujqV7OW6dztsnZdBO+p7odRuvXyy5Q2anwCY7UpqstWQPVnp7+3fcj6UpY6PW9VbH8boodgCIiADGIL1q7aiNqrICmoYQAMDs9wcDWEtEZMgaJERjLSIaAK21BgA0qPd7h4+ZCEW1aejQLdJ/CNCCITTmAKJ5GxLR26u11hhw1PVNXqpmy5T6U/JRPrqr5r7gbhSep9IXIkjTIWMz3w+SJJnPxtOXYSrTkT+dvCycKIrqqpE8iBcP0e+eGFznw9by+eNy9l6KLmPfVqt7xmZBECRpJkJ38fxFrPgwXHyfhP8AKCh5z8TmmpgAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/0237120bb455f5c518eba4d807e96bbe/e4706/zigbee2mqtt_14.avif 230w", "/en/static/0237120bb455f5c518eba4d807e96bbe/d1af7/zigbee2mqtt_14.avif 460w", "/en/static/0237120bb455f5c518eba4d807e96bbe/b6582/zigbee2mqtt_14.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/0237120bb455f5c518eba4d807e96bbe/a0b58/zigbee2mqtt_14.webp 230w", "/en/static/0237120bb455f5c518eba4d807e96bbe/bc10c/zigbee2mqtt_14.webp 460w", "/en/static/0237120bb455f5c518eba4d807e96bbe/87ca7/zigbee2mqtt_14.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/0237120bb455f5c518eba4d807e96bbe/81c8e/zigbee2mqtt_14.png 230w", "/en/static/0237120bb455f5c518eba4d807e96bbe/08a84/zigbee2mqtt_14.png 460w", "/en/static/0237120bb455f5c518eba4d807e96bbe/e9beb/zigbee2mqtt_14.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/0237120bb455f5c518eba4d807e96bbe/e9beb/zigbee2mqtt_14.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`You can copy the following JSON code and import it into Node-RED (`}<a parentName="p" {...{
        "href": "/en/Software/Linux/Node-RED/#using-node-red-to-communicate-with-your-camera"
      }}>{`How do I import flows to Node-RED?`}</a>{`):`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "json"
    }}><pre parentName="div" {...{
        "className": "language-json"
      }}><code parentName="pre" {...{
          "className": "language-json"
        }}><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"id"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"ebde9a4c.90efe8"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"type"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"link out"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"z"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"17b43655.05bd3a"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"name"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`""`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"links"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"57b22bf7.0e2874"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"5eb0d369.b3b15c"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"b5ce97db.b3f4f8"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"f335d7f4.4bbe18"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"x"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1308`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"y"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`100`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"wires"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"id"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"accb31dd.a130c"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"type"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"mqtt in"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"z"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"17b43655.05bd3a"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"name"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"Wireless Button"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"topic"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"zigbee2mqtt/smart_button"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"qos"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"1"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"broker"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"40415d07.67dd94"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"x"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`780`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"y"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`100`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"wires"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"2537690e.6230d6"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"id"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"2537690e.6230d6"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"type"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"json"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"z"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"17b43655.05bd3a"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"name"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`""`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"property"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"payload"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"action"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`""`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"pretty"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token boolean"
          }}>{`false`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"x"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`929`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"y"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`100`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"wires"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"17df313d.2e7aff"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"id"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"17df313d.2e7aff"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"type"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"change"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"z"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"17b43655.05bd3a"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"name"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"single / double"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"rules"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"t"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"set"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"p"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"payload"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"pt"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"msg"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"to"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"payload.click"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"tot"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"msg"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"action"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`""`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"property"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`""`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"from"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`""`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"to"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`""`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"reg"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token boolean"
          }}>{`false`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"x"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1076`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"y"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`100`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"wires"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"1f97ee5b.dfc642"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"id"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"1f97ee5b.dfc642"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"type"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"string"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"z"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"17b43655.05bd3a"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"name"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`""`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"methods"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"name"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"replaceAll"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"params"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"type"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"str"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"value"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"single"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"type"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"str"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"value"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"{\\"val\\" : \\"on\\"}"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"name"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"replaceAll"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"params"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"type"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"str"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"value"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"double"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"type"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"str"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"value"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"{\\"val\\" : \\"off\\"}"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"prop"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"payload"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"propout"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"payload"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"object"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"msg"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"objectout"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"msg"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"x"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1226`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"y"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`100`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"wires"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"ebde9a4c.90efe8"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"id"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"40415d07.67dd94"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"type"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"mqtt-broker"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"z"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`""`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"name"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"Debian Mosquitto"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"broker"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"localhost"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"port"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"1883"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"clientid"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`""`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"usetls"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token boolean"
          }}>{`false`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"compatmode"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token boolean"
          }}>{`true`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"keepalive"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"60"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"cleansession"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token boolean"
          }}>{`true`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"birthTopic"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`""`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"birthQos"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"0"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"birthPayload"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`""`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"closeTopic"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`""`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"closePayload"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`""`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"willTopic"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`""`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"willQos"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"0"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token property"
          }}>{`"willPayload"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`""`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span></code></pre></div>
    <p>{`The `}<strong parentName="p">{`MQTT Node`}</strong>{` outputs the message from our button as a string. We first have to turn it into a JavaScript Object with a `}<strong parentName="p">{`JSON Node`}</strong>{`.`}</p>
    <p>{`Next follows a `}<strong parentName="p">{`Change Node`}</strong>{` that changes the Message Payload to the value of `}<strong parentName="p">{`Click`}</strong>{` - as we learnt above, this value can either be `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`single`}</code>{`, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`double`}</code>{`, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`triple`}</code>{`, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`quadruple`}</code>{`, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`long`}</code>{` or `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`release`}</code>{`:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/94b7d346ea34f6ca4ab6f32de027a79d/e9beb/zigbee2mqtt_15.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "43.47826086956522%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAAA7DAAAOwwHHb6hkAAABmklEQVQoz2XPQXOTQBQHcL6gd7+LBz178TPUieN40rajjjrGaQKdNEDaZJJAEthAaCiEAGXZZVl2l3XS6Nix//kd3uU/7z3lajDQVPVS0/q9nmkYt8Hteu2tAQjDECFUPgnCuNjv9w7I450ymoyPzPHN1JqXJYRlWVUVQiV8mqLAnPnfu91nz52P58pEvZz0D8YXqmWOsixzHdd1HAAALMv/lh/6JSzSLN+GeZIo+tvXWueldvKqf/LCeveGlBhjTOu6obQmpCaEUsqa5h/GGGdCyoYxZXj6YfCpMzx/f3XasX9+QRjDqhKyZZwXCEGM6qZppRSPcClbKTnnytdvP87OPnd/9S566myxKnxvP52xbSiiuI0iGcftwyDu7kQU/RHHPAhomiqGrhuGPjJNfTicWnNuL0kYVknC7++r3S523dzfoCjiec6OsoxDWHs+XiyV678xDGNmWcwFgh1eklJWlG6jOEnTHBaYkMdnV2lGwFoxH3Io6/rMthsXCLAWm0D4G+oAOLfxYlktl2S14p53JDYBnVvE834DxO7iVp6UDxIAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/94b7d346ea34f6ca4ab6f32de027a79d/e4706/zigbee2mqtt_15.avif 230w", "/en/static/94b7d346ea34f6ca4ab6f32de027a79d/d1af7/zigbee2mqtt_15.avif 460w", "/en/static/94b7d346ea34f6ca4ab6f32de027a79d/b6582/zigbee2mqtt_15.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/94b7d346ea34f6ca4ab6f32de027a79d/a0b58/zigbee2mqtt_15.webp 230w", "/en/static/94b7d346ea34f6ca4ab6f32de027a79d/bc10c/zigbee2mqtt_15.webp 460w", "/en/static/94b7d346ea34f6ca4ab6f32de027a79d/87ca7/zigbee2mqtt_15.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/94b7d346ea34f6ca4ab6f32de027a79d/81c8e/zigbee2mqtt_15.png 230w", "/en/static/94b7d346ea34f6ca4ab6f32de027a79d/08a84/zigbee2mqtt_15.png 460w", "/en/static/94b7d346ea34f6ca4ab6f32de027a79d/e9beb/zigbee2mqtt_15.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/94b7d346ea34f6ca4ab6f32de027a79d/e9beb/zigbee2mqtt_15.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`After that follows a `}<strong parentName="p">{`String Node`}</strong>{` (this node type `}<a parentName="p" {...{
        "href": "/en/Software/Linux/Node-RED/#the-node-red-admin-panel"
      }}>{`has to be installed manually`}</a>{` - it is called `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`node-red-contrib-string`}</code>{`) that searches for the payload `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`single`}</code>{` or `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`double`}</code>{` and replaces them with something that we need to trigger the Flow below - in this case we need a JSON expression that either sets a value to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`on`}</code>{` or `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`off`}</code>{`: `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`{"val" : "on"}`}</code>{` / `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`{"val" : "off"}`}</code>{`:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "730px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/91dd9c62905bad69d7aa462741bb4935/e9beb/zigbee2mqtt_16.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "73.91304347826086%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAIAAABr+ngCAAAACXBIWXMAAA7DAAAOwwHHb6hkAAACNElEQVQoz3WRS2/TQBSF83fZ8iNYsmIHokJlwaZteFSltKJx7Cbxa8aTpipBSlvX7sux48SeOON5eNDEIQpQjq5GmpG+Ofee22hrmtZq6e22oesnJyeDweByNPoxHI5Go/R/mkziu/vx3X0DIAQQcvt9iJBt277vY4yzLMtxjjHO/5S6F0UahN1nz+GLl41+Wz/TjbO2jnqmA4Dv+3EcX19fX11dPj485Hme/aU8n03TaPgzGl02ultvDrffft967WxvdU61IAgJIUuDYkFKyvgTxTmXknHeAM0982PT2t0BXw863dMb/wbnOca5lBIXpCCsZBVlgqpzWbyqX4SCEYLQA9BzIDRNMwyVMyFEShnHycNjlKZTShnnYrNqNVzXdZYCADiOE4ZhlmVpmjLOq0owxoQQsnpCnPMVDADwPK+GOeez2SzLMsY457wsqVjrNymEmM/nCgYAQAg96NmWHYahlDKKomg8JoQIocylVN5yQ4wxBSPkIeRBCFEfucC9vb2VUi4WC0LIMlQphKjDp1TFXDuXZangbtc0TVs1b9odvRP4N2uf9WzTdIoxrvm6fc65gvd23h/s7xq68W3/aOdD8/x8KKWcTCZJkixD5pRS+Y+qqlJw68sr/eidpmm63moeH1sXF1LK8XicJElRFHU29bkJr9p2XWRZwAXIdaBlWUEQ1HOuHThjcRxnWTafzyml9UerwAy92et8Mnufe51DwzitA9vcpxCCEEIpZcvVbc78C+ckNIFb+rkwAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/91dd9c62905bad69d7aa462741bb4935/e4706/zigbee2mqtt_16.avif 230w", "/en/static/91dd9c62905bad69d7aa462741bb4935/d1af7/zigbee2mqtt_16.avif 460w", "/en/static/91dd9c62905bad69d7aa462741bb4935/b6582/zigbee2mqtt_16.avif 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/91dd9c62905bad69d7aa462741bb4935/a0b58/zigbee2mqtt_16.webp 230w", "/en/static/91dd9c62905bad69d7aa462741bb4935/bc10c/zigbee2mqtt_16.webp 460w", "/en/static/91dd9c62905bad69d7aa462741bb4935/87ca7/zigbee2mqtt_16.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/91dd9c62905bad69d7aa462741bb4935/81c8e/zigbee2mqtt_16.png 230w", "/en/static/91dd9c62905bad69d7aa462741bb4935/08a84/zigbee2mqtt_16.png 460w", "/en/static/91dd9c62905bad69d7aa462741bb4935/e9beb/zigbee2mqtt_16.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/91dd9c62905bad69d7aa462741bb4935/e9beb/zigbee2mqtt_16.png",
              "alt": "Zigbee2MQTT",
              "title": "Zigbee2MQTT",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`And last but not least we add a `}<strong parentName="p">{`Link Node`}</strong>{` to plug it in to all 4 sequences for the for the 4 alarm areas. Now every time we single-click the Wireless Button all areas are activated. A double-click deactivates them:`}</p>
    <p><img parentName="p" {...{
        "src": "/en/dd369d2cd739d1e125604e372a3b402c/nodered_01.gif",
        "alt": "Zigbee2MQTT"
      }}></img></p>
    <p>{`We attached a `}<strong parentName="p">{`Debug Node`}</strong>{` to the MQTT input to visualize the input given by the Wireless Button - `}<strong parentName="p">{`Note`}</strong>{` that only the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`single`}</code>{` and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`double`}</code>{` click trigger the Alarm Area Sequences - the rest of the input options can be used for other functions.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      